module.exports = __webpack_public_path__ + "img/about-hero-2.c13ed540.png";